// eslint-disable-next-line import/prefer-default-export
export const MAX_SEARCH_RESULTS = 100;
